import type { ProductOfferFragment } from '@/services/graphql/generated'

type Cost = ProductOfferFragment['cost']

export const YOUNG_PET_CAMPAIGN_CODE = 'FURRY'

export const isFreeMonthsDiscount = (cost: Cost): boolean => {
  // If net amount is 0, the discount is 100% meaning it's a free months discount
  return cost.net.amount === 0
}

export const includesYoungPetDiscount = (cost: Cost): boolean => {
  return cost.discountsV2.some(({ itemDiscount }) => itemDiscount.campaignCode === YOUNG_PET_CAMPAIGN_CODE)
}
